import React, { Component } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  Container,
  CircularProgress,
  Grid,
  MenuItem,
  FormControl,
  List,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MobileHeader from "../MobileHeader";
import { Form, Link } from "react-router-dom";
import { WithRouter } from "../../comp/WithRouter";
import { CartContext } from "../../comp/CartContext";
import MapDisplay from "../MapDisplay";
import { toast } from "react-toastify";
import AddressSelector from "./AddressSelector";
class Adress extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      cep: "",
      loading: false,
      step: 1,
      Address: [],
      color: '',
      endereco: {
        logradouro: "",
        numero: "",
        bairro: "",
        complemento: "",
        pontoReferencia: "",
        localidade: "",
        uf: "",
      },
      loader: true
    };
  }

  componentDidMount() {
    this.setState({ color: this.context.data.color || '#1976d2' })
    fetch("/api/store/address", {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      if (response.status == 200) {
        response.json().then((Address) => {
          this.setState({ Address, loader: false });
        });
      }
    })
  }

  handleCepChange = (event) => {
    const value = event.target.value.replace(/\D/g, "").slice(0, 8);
    const formatted =
      value.length > 5 ? `${value.slice(0, 5)}-${value.slice(5)}` : value;
    this.setState({ cep: formatted });
  };
  handleCepChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Remove tudo que não é número

    if (value.length <= 8) {
      // Aplica a máscara 00000-000
      let formattedValue = value.replace(/^(\={5})(\d)/, "$1-$2");
      if (value.length > 5) {
        formattedValue = `${value.slice(0, 5)}-${value.slice(5, 8)}`;
      } else {
        formattedValue = value;
      }

      this.setState({ cep: formattedValue }, () => {
        // Se completou os 8 números, dispara a busca
        if (value.length === 8) {
          this.buscarCep();
        }
      });
    }
  };
  buscarCep = async () => {
    const cleanCep = this.state.cep.replace(/\D/g, "");
    if (cleanCep.length !== 8) return;

    this.setState({ loading: true });

    try {
      const response = await fetch(
        `https://viacep.com.br/ws/${cleanCep}/json/`
      );
      const data = await response.json();

      if (!data.erro) {
        this.setState({
          step: 2,
          loading: false,
          endereco: {
            ...this.state.endereco,
            logradouro: data.logradouro || "",
            bairro: data.bairro || "",
            localidade: data.localidade || "",
            cep: data.cep || "",
            uf: data.uf || "",
          },
        });
      } else {
        toast.warn("CEP inválido");
        this.setState({ loading: false });
      }
    } catch (error) {
      this.setState({ loading: false });
    }
  };

  handleInputChange = (field) => (event) => {
    this.setState({
      endereco: { ...this.state.endereco, [field]: event.target.value },
    });
  };

  renderStep1() {
    return (
      <Box
        sx={{ textAlign: "center", mt: 6, px: 3, maxWidth: 400, mx: "auto" }}
      >
        <Typography
          sx={{
            color: "#546e7a",
            mb: 4,
            fontSize: "1rem",
            fontWeight: 500,
            lineHeight: 1.5,
          }}
        >
          Onde deseja receber seu pedido?
          <br />
          <span
            style={{ fontSize: "0.85rem", fontWeight: 400, color: "#90a4ae" }}
          >
            Informe seu CEP para consulta de entrega
          </span>
        </Typography>

        <Box
          sx={{ position: "relative", display: "inline-block", width: "100%" }}
        >
          <TextField
            variant="standard"
            placeholder="00000-000"
            type="text"
            value={this.state.cep}
            onChange={this.handleCepChange}
            disabled={this.state.loading}
            autoFocus
            InputProps={{
              disableUnderline: true,
              sx: {
                fontSize: "2.8rem", // Aumentado para impacto visual
                fontWeight: 200,
                letterSpacing: "2px",
                color: this.state.loading ? "#cfd8dc" : "#263238",
                "& input": {
                  textAlign: "center",
                  padding: 0,
                },
              },
            }}
            sx={{ mb: 2, width: "100%" }}
          />

          {/* Loader sutil abaixo do número ou sobreposto */}
          {this.state.loading && (
            <CircularProgress
              size={24}
              sx={{
                position: "absolute",
                bottom: -20,
                left: "50%",
                marginLeft: "-12px",
                color: "#ff9e80",
              }}
            />
          )}
        </Box>

        <Box sx={{ mt: 5 }}>
          <Link
            component="button"
            variant="body2"
            onClick={() =>
              window.open("https://buscacepinter.correios.com.br/", "_blank")
            }
            sx={{
              fontWeight: 600,
              color: "#ff8a65",
              textDecoration: "none",
              "&:hover": { textDecoration: "underline" },
            }}
          >
            Não sei meu CEP
          </Link>
        </Box>
      </Box>
    );
  }

  renderStep2() {
    const { endereco } = this.state;

    const inputStyle = { "& .MuiOutlinedInput-root": { borderRadius: "8px" } };

    return (
      <>
        <Box sx={{ flexGrow: 1, p: 2, paddingBottom: 0 }}>
          <div style={{ display: "flex", gap: "10px" }}>
            <TextField
              label="Rua"
              variant="outlined"
              required
              value={endereco.logradouro}
              onChange={this.handleInputChange("logradouro")}
              size="small"
              defaultValue="Rua Machadinho"
              sx={{ flex: 4 }} // Ocupa 4 partes do espaço (80%)
            />
            <TextField
              label="Nº"
              size="small"
              value={endereco.numero}
              onChange={this.handleInputChange("numero")}
              variant="outlined"
              sx={{ flex: 1 }} // Ocupa 1 parte do espaço (20%)
            />
          </div>
          <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
            <TextField
              label="Bairro"
              variant="outlined"
              required
              value={endereco.bairro}
              onChange={this.handleInputChange("bairro")}
              size="small"
              sx={{ flex: 4 }} // Ocupa 4 partes do espaço (80%)
            />
          </div>

          <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
            <TextField
              label="Complemento"
              variant="outlined"
              required
              value={endereco.complemento}
              onChange={this.handleInputChange("complemento")}
              size="small"
              sx={{ flex: 4 }} // Ocupa 4 partes do espaço (80%)
            />
          </div>
          <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
            <TextField
              label="Ponto de Referência"
              variant="outlined"
              required
              value={endereco.referencia}
              onChange={this.handleInputChange("referencia")}
              size="small"
              sx={{ flex: 4 }} // Ocupa 4 partes do espaço (80%)
            />
          </div>
          <div style={{ display: "flex", gap: "10px", marginTop: "15px" }}>
            <TextField
              label="Cidade"
              variant="outlined"
              required
              size="small"
              value={endereco.localidade}
              onChange={this.handleInputChange("localidade")}
              sx={{ flex: 4 }} // Ocupa 4 partes do espaço (80%)
            />
            <TextField
              label="Estado"
              size="small"
              disabled
              value={endereco.uf}
              onChange={this.handleInputChange("uf")}
              variant="outlined"
              sx={{ flex: 1 }} // Ocupa 1 parte do espaço (20%)
            />
          </div>
        </Box>

        <Box sx={{ flexGrow: 1, p: 2 }}>
          <Button
            variant="contained"
            fullWidth
            sx={{ bgcolor: this.state.color, fontWeight: "bold", py: 1.5 }}
            onClick={() => {
              var endereco = this.state.endereco;
              fetch(`/api/store/calculate_tax`, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  full_address: `${endereco.logradouro}, ${endereco.numero} -  ${endereco.bairro}, ${endereco.localidade} -  ${endereco.uf}`,
                  street: endereco.logradouro,
                  district: endereco.bairro,
                  address_complement: endereco.complemento,
                  landmark: endereco.referencia,
                  house_number: endereco.numero,
                  city: endereco.localidade,
                  state: endereco.uf,
                  zip_code: endereco.cep,

                }),
              })
                .then((response) => response.json())
                .then((data) => {
                  this.context.AdicionarEndereco({
                    logradouro: endereco.logradouro,
                    numero: endereco.numero,
                    bairro: endereco.bairro,
                    complemento: endereco.complemento,
                    pontoReferencia: endereco.referencia,
                    localidade: endereco.localidade,
                    uf: endereco.uf,
                    distance: data.distance,
                    lat: data.lat,
                    lng: data.lng,
                  });
                  this.props.navigate(-1);
                })
                .catch((error) => {
                  console.error("Error:", error);
                });
            }}
          >
            CONFIRMAR
          </Button>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => this.setState({ step: 1 })}
            sx={{
              mt: 2,
              color: this.state.color,
              borderColor: "red",
              fontWeight: "bold",
              py: 1.5,
            }}
          >
            VOLTAR
          </Button>
        </Box>
      </>
    );
  }

  render() {
    const { Address } = this.state;
    const enderecoPadrao = Address.find((item) => item.default === 1);

    return (<AddressSelector addresses={Address} />)
  }
}

export default WithRouter(Adress);
